// extracted by mini-css-extract-plugin
module.exports = {"button":"ArchiveButton_button__1KUiL","icon":"ArchiveButton_icon__3DsIA"};